import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";

//components
import PartnersLogo from "./components/Partners/partners_logo";
// @mui material components

import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import getHorizontalBarChartData from "./data/horizontalBarChartData";
import getPieChartData from "./data/pieChartData";
//import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
//import getLineChartData from "./data/lineChartData";
import CustomChannelsChart from "components/CustomChannelsChart";
import MDInput from "components/MDInput";
import { useCallback, useEffect, useState } from "react";
import { getQuarters, getSalesSummaryByYear } from "rest/requests";
import getSalesData from "../../../models/getSalesData";
// Data

function SalesSummary() {
  const [year, setYear] = useState(new Date().getFullYear());
  const [salesSummaryList, setSalesSummaryList] = useState([]);

  // ------ Year select ----------
  const current_year = new Date().getFullYear();
  const handleYear = (event) => {
    const {
      target: { value },
    } = event;
    if (value <= current_year) {
      setYear(value);
    }
  };
  // ------ Year select END----------

  const getData = useCallback(async () => {
    console.log("getData.useCallback");
    const _quarters = await getQuarters(year);
    const quartersId = _quarters.length > 0 ? _quarters : [182, 64, 46, 47];
    const dataTemp = await getSalesSummaryByYear(year);
    setSalesSummaryList(getSalesData(dataTemp, quartersId));
  }, [year]);

  useEffect(() => {
    setSalesSummaryList([]);
    getData();
  }, [year]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container>
          <Grid item>
            <MDInput type="number" label="Year" value={year} onChange={handleYear} />
          </Grid>
        </Grid>
      </MDBox>
      <br></br>
      <MDBox mb={6}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <VerticalBarChart
              icon={{ color: "dark", component: "leaderboard" }}
              title={"Resumen de Ventas: " + year}
              description="Representacion total por empresas"
              chart={getHorizontalBarChartData(salesSummaryList, year)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomChannelsChart
              title={"Top 5 Empresas: " + year}
              description="Representacion del Total de ventas"
              data={getPieChartData(salesSummaryList)}
            ></CustomChannelsChart>
          </Grid>
        </Grid>
      </MDBox>

      <PartnersLogo />
      <Footer />
    </DashboardLayout>
  );
}

export default SalesSummary;
